const WhyChooseYesSection = () => {
  const benefits = [
    {
      icon: '/img/career/Group-1962.png',
      title: 'Health Support',
      description:
        'Kesehatan adalah aspek terpenting, YES memberikan dukungan kesehatan bagi Pegawai berupa asuransi pribadi dan BPJS sesuai dengan ketentuan Pemerintah Republik Indonesia.',
    },
    {
      icon: '/img/career/Group-1962.png',
      title: 'Tunjangan Hari Raya (THR)',
      description:
        'Memberikan THR ke Pegawai YES sesuai dengan hari raya keagamaan masing-masing pegawai.',
    },
    {
      icon: '/img/career/Group-1962.png',
      title: 'Team Outing & Gathering',
      description:
        'Untuk memperkuat kolaborasi antar tim, YES secara rutin mengadakan kegiatan outing dan Gathering bagi para pegawai.',
    },
    {
      icon: '/img/career/Group-1962.png',
      title: 'Cuti',
      description:
        'Mendapatkan cuti tahunan sebanyak 12x per tahun, disertai beberapa cuti lainnya. Seperti cuti sakit (tidak terbatas dengan surat dokter), cuti menstruasi, cuti hamil, cuti di luar tanggungan (unpaid leave), cuti lembur, dan lainnya.',
    },
    {
      icon: '/img/career/Group-1962.png',
      title: 'Learning Benefit',
      description:
        'Selama bekerja bersama YES, Pegawai bisa mendapatkan akses eksklusif ke berbagai platform belajar YES. Ingin belajar di platform lain di luar YES? Tentu bisa! Pegawai bisa melakukan request untuk mengakses platform lain di luar YES.',
    },
  ]

  const teamImages = [
    '/img/about-us/IMG_0413-2.png',
    '/img/about-us/DSC01142-1.png',
    '/img/about-us/DSC07786-1.png',
    '/img/about-us/DSC00944-1.png',
  ]

  return (
    <section className="bg-gray-50">
      <div className="flex flex-col gap-12 lg:gap-20">
        <div className="w-full">
          {/* Section Title */}
          <div className="mb-10">
            <h2 className="mb-6 text-center text-3xl font-bold lg:text-5xl">
              <span className="text-gray-800">Mengapa Memilih</span>
              <span className="text-red-600"> YES</span>
              <span className="text-gray-800">?</span>
            </h2>

            <p className="text-center text-lg leading-relaxed text-gray-600">
              <span>
                Dalam rangka mewujudkan komitmen kami untuk menciptakan suasana
                kerja yang suportif,{' '}
              </span>
              <span className="font-semibold text-red-600">YES Academy </span>
              <span>
                menyediakan berbagai jenis keuntungan eksklusif untuk menjaga
                kesejahteraan Pegawai
              </span>
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="mb-10 flex flex-wrap items-center justify-center gap-5 px-4 lg:px-12">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="h-[300px] max-w-sm rounded-lg border border-gray-300 p-6 shadow-sm transition-shadow duration-300 hover:shadow-md"
              >
                <div className="mb-4 flex items-start gap-4">
                  <img
                    src={benefit.icon}
                    alt=""
                    className="mt-1 h-6 w-6 flex-shrink-0"
                  />
                  <h3 className="text-xl font-semibold text-gray-800">
                    {benefit.title}
                  </h3>
                </div>
                <p className="pl-10 leading-relaxed text-gray-600">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          {/* image corousal */}
          <div className="relative overflow-hidden rounded-lg">
            <div className="animate-scroll-left flex">
              {/* First set */}
              {teamImages.map((image, index) => (
                <img
                  key={`first-${index}`}
                  src={image}
                  alt={`Team activity ${index + 1}`}
                  className="mr-4 h-72 w-96 object-cover shadow-lg transition-shadow duration-300 hover:shadow-xl lg:h-80 lg:w-[500px]"
                />
              ))}
              {/* Duplicate for seamless loop */}
              {teamImages.map((image, index) => (
                <img
                  key={`second-${index}`}
                  src={image}
                  alt={`Team activity ${index + 1}`}
                  className="mr-4 h-72 w-96 object-cover shadow-lg transition-shadow duration-300 hover:shadow-xl lg:h-80 lg:w-[500px]"
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for animation */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @keyframes scroll-left {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          
          .animate-scroll-left {
            animation: scroll-left 20s linear infinite;
          }
          
          .animate-scroll-left:hover {
            animation-play-state: paused;
          }
        `,
        }}
      />
    </section>
  )
}

export default WhyChooseYesSection
